import React, { useState } from 'react'
import clsx from 'clsx'
import { Autocomplete as MUIAutocomplete } from '@material-ui/lab'
import {
  TextField,
  FormControl,
  InputAdornment,
  IconButton,
} from '@material-ui/core'
import { ReactComponent as AutocompleteIcon } from '../../../images/autocomplete-icon.svg'
import useStyles from './FormFieldsStyle'

export default function Autocomplete({ field, values, errors }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')

  return (
    <FormControl fullWidth className={classes.withMargin} variant="outlined">
      <div className={classes.inputLabel} shrink>
        {field.label}
      </div>
      <MUIAutocomplete
        options={field.options || []}
        open={open}
        onOpen={() => {
          setOpen(true)
        }}
        loadingText={<span style={{ color: 'white' }}>Loading...</span>}
        noOptionsText={<span style={{ color: 'white' }}>No options</span>}
        onClose={() => setOpen(false)}
        getOptionLabel={
          field.getOptionLabel
            ? field.getOptionLabel
            : (option) => {
                if (option.name) {
                  return option.name
                }
              }
        }
        classes={{
          option: classes.selectOption,
          paper: classes.selectPaper,
        }}
        renderOption={
          field.renderOption ? field.renderOption : (option) => option.name
        }
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              className: clsx(
                params.InputProps.className,
                {
                  [classes.inputFont]: !values[field.key],
                },
                classes.inputRoot
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className={classes.iconButton}
                    onMouseDown={(event) => {
                      event.preventDefault()
                      setOpen((prevOpen) => !prevOpen)
                    }}
                  >
                    <AutocompleteIcon />
                  </IconButton>
                </InputAdornment>
              ),
              onBlur: (event) => {
                if (field.onBlur) {
                  field.onBlur(event)
                }
              },
            }}
            placeholder={field.hint}
            variant="outlined"
            className={clsx(classes.customBorder, classes.inputFont)}
            error={errors && !!errors[field.key]}
            helperText={errors && errors[field.key]}
          />
        )}
        renderTags={field.renderTags}
        name={field.key}
        value={field.value ?? values[field.key]}
        inputValue={
          field.inputValue && field.inputValue !== ''
            ? field.inputValue
            : inputValue
        }
        onInputChange={(event, newInputValue, reason) => {
          setInputValue(newInputValue)
          if (field.onInputChange) {
            field.onInputChange(event, newInputValue, reason)
          }
        }}
        onChange={(evt, value) => {
          if (errors) {
            delete errors[field.key]
          }
          field.onChange(value)
        }}
        multiple={field.multiple}
        freeSolo={field.freeSolo}
        disabled={field.disabled}
        filterOptions={field.filterOptions}
        loading={field.loading}
        className={clsx(
          field.withRightMargin && classes.withRightMargin,
          classes.centerText
        )}
      />
      {field.infoBellowTitle && field.infoBellowContent && (
        <FormControl>
          <div className={classes.infoBelowAutocomplete}>
            <div>{field.infoBellowTitle}</div>
            <div>{field.infoBellowContent}</div>
          </div>
        </FormControl>
      )}
    </FormControl>
  )
}
